import { formatNumber } from '../utils/formatUtils';

const TeamStatus = ({ users = [] }) => {
  // Expand dummy users with mocked current logged hours for the week
  const teamLogs = users.map(user => {
    // Generate some random hours for the demo
    const isMgt = user.roleScope === 'Management';
    const loggedStr = isMgt ? (32 + Math.floor(Math.random() * 8)) : (38 + Math.floor(Math.random() * 12));
    
    return {
      ...user,
      loggedHours: loggedStr,
      targetHours: 40
    };
  });

  return (
    <div className="max-w-5xl mx-auto h-full flex flex-col">
      <div className="mb-6">
        <h1 className="text-3xl font-extrabold text-slate-900 tracking-tight">Team Status Directory</h1>
        <p className="text-sm text-slate-500 mt-2">Monitor workforce utilization and active headcount across JV partners.</p>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
        <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-slate-50 text-slate-400 text-xs font-bold uppercase tracking-wider border-b border-slate-200">
                <th className="px-6 py-4">Team Member</th>
                <th className="px-6 py-4 flex items-center">
                   Home Company
                </th>
                <th className="px-6 py-4">Role Scope</th>
                <th className="px-6 py-4">Cost Center</th>
                <th className="px-6 py-4 w-1/4">Weekly Utilization</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {teamLogs.map(member => {
                 const percent = Math.min(Math.round((member.loggedHours / member.targetHours) * 100), 100);
                 const overage = member.loggedHours > member.targetHours;
                 
                 return (
                   <tr key={member.id} className="hover:bg-blue-50/30 transition-colors">
                     <td className="px-6 py-4">
                       <div className="flex items-center">
                         <div className="w-8 h-8 rounded-full bg-blue-100 text-blue-700 font-bold flex items-center justify-center mr-3">
                           {member.name.charAt(0)}
                         </div>
                         <div>
                           <div className="font-bold text-slate-900">{member.name}</div>
                           <div className="text-xs text-slate-500">{member.personnelNumber}</div>
                         </div>
                       </div>
                     </td>
                     <td className="px-6 py-4">
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold bg-slate-100 text-slate-800">
                           {member.company}
                        </span>
                     </td>
                     <td className="px-6 py-4 text-sm font-semibold text-slate-700">
                       {member.roleScope}
                     </td>
                     <td className="px-6 py-4 font-mono text-xs text-slate-500 font-bold">
                       {member.costCenter}
                     </td>
                     <td className="px-6 py-4">
                        <div className="flex justify-between items-end mb-1">
                          <span className="text-xs font-bold text-slate-600">{percent}%</span>
                          <span className={`text-xs font-bold ${overage ? 'text-red-600' : 'text-slate-500'}`}>
                             {formatNumber(member.loggedHours)} / {formatNumber(member.targetHours)}h
                          </span>
                        </div>
                        <div className="w-full bg-slate-200 rounded-full h-2">
                           <div 
                             className={`h-2 rounded-full ${overage ? 'bg-red-500' : 'bg-blue-600'}`} 
                             style={{ width: `${percent}%` }}
                           ></div>
                        </div>
                     </td>
                   </tr>
                 );
              })}
            </tbody>
        </table>
      </div>
    </div>
  );
};

export default TeamStatus;
